import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SubmitButton from './SubmitButton';
import translate from '../../../commonComponents/translate';

function Evaluation({ t, questionId, options, value, onSubmit }) {
  const [selectedAnswer, setSelectedAnswer] = useState(
    value ? value.evaluation : Math.floor(options / 2),
  );
  useEffect(
    () => setSelectedAnswer(value ? value.evaluation : Math.floor(options / 2)),
    [questionId],
  );

  const handleSubmit = () => onSubmit({ evaluation: selectedAnswer });

  return (
    <div className="m-portlet__body quiz-answers-container">
      <h4>{t('survey_evaluation_hint')}</h4>
      <div className="quiz-answer-list">
        <div className="quiz-input-container">
          <span className="quiz-evaluation-value">{selectedAnswer}</span>
          <input
            type="range"
            min={1}
            max={options}
            value={selectedAnswer}
            onChange={({ currentTarget }) =>
              setSelectedAnswer(Number(currentTarget.value))
            }
          />
        </div>
      </div>
      <SubmitButton
        onSubmit={handleSubmit}
        text={t('survey_setEvaluation')}
        disabled={false}
      />
    </div>
  );
}

Evaluation.propTypes = {
  t: PropTypes.func.isRequired,
  questionId: PropTypes.string.isRequired,
  value: PropTypes.shape({ evaluation: PropTypes.number.isRequired }),
  options: PropTypes.number.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

Evaluation.defaultProps = {
  value: null,
};

export default translate(Evaluation);
